var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBucketPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6284 22.666L15.7534 24.791L20.3576 20.541",
    stroke: "#735BF2",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4809 2.83301L7.35254 7.97551",
    stroke: "#735BF2",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.5192 2.83301L26.6476 7.97551",
    stroke: "#735BF2",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.83337 11.1204C2.83337 8.49961 4.23587 8.28711 5.97837 8.28711H28.0217C29.7642 8.28711 31.1667 8.49961 31.1667 11.1204C31.1667 14.1663 29.7642 13.9538 28.0217 13.9538H5.97837C4.23587 13.9538 2.83337 14.1663 2.83337 11.1204Z",
    stroke: "#735BF2",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.95837 14.166L6.95587 26.406C7.40921 29.1543 8.50004 31.166 12.5517 31.166H21.0942C25.5 31.166 26.1517 29.2393 26.6617 26.576L29.0417 14.166",
    stroke: "#735BF2",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucketPrimary);
export default __webpack_public_path__ + "static/media/bucketPrimary.a54d7fd08809d0d815633685e02fc39e.svg";
export { ForwardRef as ReactComponent };